import { Box, Button, Container } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SectionHeading } from "../../../components/SectionHeading";
import { FramedImage } from "../../../components/FramedImage";

export function Highlight({ image, overline, title, description }) {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 16 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1.1fr" },
            gap: { xs: 6, md: 10 },
            alignItems: "center",
          }}
        >
          <FramedImage src={image} alt={title} objectPosition="center 35%" />

          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <SectionHeading overline={overline} title={title} subtitle={description} align="inherit" />
            <Button component={RouterLink} to="/videos" variant="outlined" size="large" sx={{ px: 4, mt: { xs: -2, md: -4 } }}>
              Assistir vídeos
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
